document.addEventListener("DOMContentLoaded", () => {
  const countdownElements = document.querySelectorAll('.countdown-timer');
  countdownElements.forEach(initCountdown);
});

function initCountdown(countdownElement) {
  const startAttr = countdownElement.getAttribute('data-start');
  const endAttr = countdownElement.getAttribute('data-end');
  const timerLabel = countdownElement.querySelector('.timer-label');
  const timerValue = countdownElement.querySelector('.timer-value');

  if (!startAttr || !endAttr || !timerLabel || !timerValue) return;

  const startTime = parseInt(startAttr, 10) * 1000;
  const endTime = parseInt(endAttr, 10) * 1000;

  const labels = {
    day: {
      singular: countdownElement.dataset.labelDaySingular || 'dag',
      plural: countdownElement.dataset.labelDayPlural || 'dagar'
    },
    hour: {
      singular: countdownElement.dataset.labelHourSingular || 'timme',
      plural: countdownElement.dataset.labelHourPlural || 'timmar'
    },
    minute: {
      singular: countdownElement.dataset.labelMinuteSingular || 'minut',
      plural: countdownElement.dataset.labelMinutePlural || 'minuter'
    }
  };

  function pluralize(value, singular, plural) {
    return value === 1 ? singular : plural;
  }

  function formatTime(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    let result = '';

    if (days > 0) {
      result += `${days} ${pluralize(days, labels.day.singular, labels.day.plural)}, `;
    }

  
if (hours > 0 || days === 0) {
  result += `${hours} ${pluralize(hours, labels.hour.singular, labels.hour.plural)}, `;
}


    result += `${minutes} ${pluralize(minutes, labels.minute.singular, labels.minute.plural)}.`;
    return result;
  }

  function updateTimer() {
    const now = Date.now();

    if (now < startTime) {
      countdownElement.style.display = 'none';
    } else if (now <= endTime) {
      countdownElement.style.display = '';
      timerValue.textContent = formatTime(endTime - now);
    } else {
      countdownElement.style.display = 'none';
      clearInterval(timerInterval);
    }
  }

  const timerInterval = setInterval(updateTimer, 1000);
  updateTimer();
}
